import React from "react";

import Styles from "./TicketCardContainer.styles";
import { TicketCardContainerProps as Props } from "./TicketCardContainer.types";

const TicketCardContainer: React.FC<Props> = props => {
  const { children, className, contentClassName } = props;

  return (
    <Styles className={`TicketCardContainer ${className}`}>
      <div className="TicketCardContainer__dot-container TicketCardContainer__left-dot-container">
        <div className="TicketCardContainer__dot" />
      </div>

      <div className={contentClassName}>{children}</div>

      <div className="TicketCardContainer__dot-container TicketCardContainer__right-dot-container">
        <div className="TicketCardContainer__dot" />
      </div>
    </Styles>
  );
};

export default TicketCardContainer;
